<template>
  <b-container>
    <h1 class="text-center pt-4 pb-4">{{ $t("title.groupManagement") }}</h1>

    <GroupAssociateBuildingToTeam />
    
  </b-container>
</template>

<script>
import { globalF } from "../../Helpers";
import GroupAssociateBuildingToTeam from "./GroupAssociateBuildingToTeam.vue";

export default {
  mixins: [globalF],
  data() {
    return {
      active: '',
    };
  },
  validations() {},
  mounted() {},
  computed: {},
  methods: {
    setNextPage(page) {
      this.$emit("changePage", page);
    },
  },
  components: {
    GroupAssociateBuildingToTeam
  },
};
</script>
